// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__82qAT","perPageSelector":"Pagination_perPageSelector__ICcWi"};